import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

type Props = {
  title: string
}

const useStyles = makeStyles(() => ({
  title: {
    fontStyle: 'normal',
    fontHeight: 'normal',
    fontSize: '24px',
    lineHeight: '24px',
    color: '#4B4B4B',
    marginTop: '4px'
  }
}))

export default function PageTitle ({ title }: Props): JSX.Element {
  const classes = useStyles()

  return (
    <Typography className={classes.title}>{title}</Typography>
  )
}
